module.exports = __webpack_public_path__ + "static/media/fs-left.c134b4ad.png";